import Vue from 'vue';

export default {
  getPreinvoice() {
    return Vue.prototype.axios
      .get('getpreInvoice', {
        params: {
          orderId: Vue.prototype.$session.get('orderIdDMS'),
          // dealerId: Vue.prototype.$session.get("dealerIdExt")
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const response = res.data;

        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);

        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getInvoices(userId) {
    return Vue.prototype.axios
      .get('getInvoices', {
        params: {
          orderId: Vue.prototype.$session.get('orderId'),
          userId,
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const response = res.data;

        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);

        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  getInvoice(invoiceId, dealerId) {
    return Vue.prototype.axios
      .get('getInvoice', {
        params: {
          orderId: Vue.prototype.$session.get('orderId'),
          invoiceId,
          dealerId,
        },
      })
      .then((res) => {
        const responseInvoice = res.data;

        if (!responseInvoice.success) throw new Error(`[${responseInvoice.errorCode}] ${responseInvoice.errorDescription}`);

        return responseInvoice;
      })
      .catch((error) => {
        throw error;
      });
  },
  getInvoiceParams(orderId) {
    return Vue.prototype.axios
      .get('getInvoice', {
        params: {
          orderId,
          // dealerId: Vue.prototype.$session.get("dealerIdExt")
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const responseInvoiceParams = res.data;

        if (!responseInvoiceParams.success) throw new Error(`[${responseInvoiceParams.errorCode}] ${responseInvoiceParams.errorDescription}`);

        return responseInvoiceParams;
      })
      .catch((error) => {
        throw error;
      });
  },
};
